import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../context/app-context';
import { useScroll } from '../../../context/scroll-context';

const ChoosePath = () => {
    const navigate = useNavigate()
    const { setActiveTab } = useAppContext()

    const handlePageLink = (path) => {
        navigate(path);
        setActiveTab("Hire Team");
    }

    const { scrollToSection, contactform } = useScroll();

    const handleScrollAndClose = (refName) => {
        scrollToSection(refName);
    };

    const developerImg = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/home/developer-img.webp"
    const systemImg = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/home/system-img.webp"

    return (
        <section className="grey-bg py-5" id="choose-path">
            <Container>
                <Row>
                    <Col xs={12}>
                        <h2 className="text-primary text-center mb-4 text-uppercase ft-wt-700">Choose Your Path</h2>
                    </Col>

                    <Col xs={12} lg={6} className="mb-3">
                        <Card className="h-100 info-card">
                            <Card.Img variant="top" src={developerImg} alt="developer" className="path-section-img" />
                            <Card.Body>
                                <Card.Title as="h3" className="text-primary ft-wt-700">
                                    Hire a World Class Developer
                                </Card.Title>
                                <div className="card-content flex-grow-1">
                                    <h5 className="mb-1">Select this journey if:</h5>
                                    <h5>
                                        You have a tech department, and want to add a highly-skilled developer to your team
                                    </h5>
                                </div>
                                <div>
                                    <Button variant="primary" onClick={() => handlePageLink("/services")}>
                                        HIRE NOW
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} lg={6} className="mb-3">
                        <Card className="h-100 info-card">
                            <Card.Img variant="top" src={systemImg} alt="idea" className="path-section-img" />
                            <Card.Body>
                                <Card.Title as="h3" className="text-primary ft-wt-700">
                                    Turn your idea into a software product
                                </Card.Title>
                                <div className="card-content flex-grow-1">
                                    <h5 className="mb-1">Select this journey if:</h5>
                                    <h5>
                                        You have an idea that you want to turn into a profitable software product
                                    </h5>
                                </div>
                                <div>
                                    <Button variant="primary" onClick={() => handleScrollAndClose(contactform)}>
                                        GET IN TOUCH
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ChoosePath;
